<template>
    <div>
        <div v-if="locations" style="z-index: 1000">
            <md-autocomplete
                :md-fuzzy-search="false"
                :md-options="locations"
                :value="value"
                md-dense
                :md-input-placeholder="'Zoek op locatie naam'"
                :md-open-on-focus="true"
                @md-changed="setLocationList"
                @md-opened="setLocationList"
                @md-selected="setSelectedLocation"
                style="z-index: 1000"
            >
                <label>Location</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">
                    {{ item.location_name }}
                </template>

                <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                    <md-highlight-text :md-term="term">
                        {{ item.location_name + ' (' + item.location_id + ')' }}
                    </md-highlight-text>
                </template>

                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                    No loctions matching "{{ term }}" were found!
                </template>
            </md-autocomplete>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import { ReplaySubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { ILocationSearchEntity, ILocationsSearchFilterEntity, LocationApi, RequestSort } from '@phrospr/api-backend';
import toastr from 'toastr';

@Component({
    components: {},
})
export default class LocationSearchModal extends Vue {
    filter: ILocationsSearchFilterEntity = {
        location_name: '',
    };

    get locations() {
        return Promise.resolve(this.$store.state.locationSearch);
    }

    value = '';
    selectedLocationValue = '';

    searchTerm$ = new ReplaySubject(1);
    searchTermSubscription;

    constructor() {
        super();
        this.searchTermSubscription = this.searchTerm$
            .pipe(
                debounceTime(300),
                tap((searchTerm: string) => {
                    if (searchTerm === undefined) return;
                    this.filter.location_name = searchTerm ?? undefined;
                    this.searchLocations();
                }),
            )
            .subscribe();
        this.searchLocations();
    }

    setLocationList = searchTerm => {
        this.searchTerm$.next(searchTerm);
    };

    async searchLocations() {
        const locationSearchFilter: ILocationSearchEntity = {
            filter: this.filter,
            limit: 10,
            sort: { order: RequestSort.ASC, column: 'name' },
            offset: 0,
            show: {},
        };
        try {
            this.$store.commit(
                'setLocationSearch',
                (await LocationApi.listLocations(locationSearchFilter)).data.records,
            );
            this.$forceUpdate();
        } catch (e) {
            console.error(e);
            toastr.error('er ging iets mis bij het zoeken naar een locatie');
        }
    }

    @Emit() setSelectedLocation(selectedLocation) {
        this.selectedLocationValue = selectedLocation.location_name;
        return selectedLocation;
    }
}
</script>

<style scoped></style>
